const Documents = () => {
  return <div>This Document Page</div>;
  
};

export default Documents;
